import { render, staticRenderFns } from "./Secret2.vue?vue&type=template&id=5f31fd86&scoped=true&"
import script from "./Secret2.vue?vue&type=script&lang=js&"
export * from "./Secret2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f31fd86",
  null
  
)

export default component.exports